const cssStyles = () => `
.TermsOfService__light a {
  color: rgba(255,255,255,0.9);
}
`;

export default cssStyles;
